import { api } from '../apiClient';

export interface OrganizationMicrositeParams {
  page?: number;
  search?: string;
  status?: string;
  ordering?: string;
}

export interface OrganizationMicrositeResponse {
  organization: {
    slug: string;
    name: string;
    description: string;
    logo_url: string | null;
    email: string | null;
    website: string | null;
    social_links: Record<string, string | null>;
    hero_title: string;
    hero_subtitle: string;
    custom_banner_url: string | null;
    about_title: string;
    about_content: string | null;
    about_image_url: string | null;
    featured_video_url: string | null;
    featured_image_url: string | null;
    contact_email: string | null;
    contact_phone: string | null;
    contact_address: string | null;
    show_contact_form: boolean;
    enable_newsletter_signup: boolean;
    meta_title: string;
    meta_description: string;
    primary_color: string;
    secondary_color: string;
    custom_css: string;
    show_past_events: boolean;
    show_event_categories: boolean;
    events_per_page: number;
    testimonials: unknown[];
    achievements: unknown[];
    is_subscribed: boolean;
  };
  events: unknown[];
  upcoming_events: unknown[];
  past_events: unknown[];
  event_categories: { id: number; name: string }[];
  pagination: {
    current_page: number;
    total_pages: number;
    total_events: number;
    has_next: boolean;
    has_previous: boolean;
    next_page: number | null;
    previous_page: number | null;
  };
  filters: {
    search: string | null;
    status: string | null;
    ordering: string | null;
  };
}

export const organizationService = {
  getMicrosite: async (
    slug: string,
    params: OrganizationMicrositeParams = {}
  ): Promise<OrganizationMicrositeResponse> => {
    const queryParams = new URLSearchParams();
    if (params.page != null) queryParams.append('page', params.page.toString());
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.ordering) queryParams.append('ordering', params.ordering);
    const url = `/organizations/${slug}/microsite/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    const response = await api.get<OrganizationMicrositeResponse>(url);
    return response.data;
  },

  subscribe: async (slug: string): Promise<{ success: boolean; message: string; already_subscribed?: boolean }> => {
    const response = await api.post<{ success: boolean; message: string; already_subscribed?: boolean }>(
      `/organizations/${slug}/subscribe/`
    );
    return response.data;
  },
};
